import { Link } from 'react-router-dom';
import styles from './Footer.module.css';
import logo from '../../assets/images/bottom-logo.png'

const Footer = () => {

	return(
		<section className='pb-4'>
			<div className='container'>
				<div className='col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2 text-center'>
					<div className={styles.BorderTop}></div>
					<img src={logo} alt='FiscalNote' className={styles.Logo} />
					<p class="text-sm text-gray-500 leading-relaxed">
						FiscalNote (
							<a 
								href="https://investors.fiscalnote.com/overview/default.aspx?_gl=1*ay61i1*_gcl_au*ODgyNTM1MDc2LjE3NjM1ODIxMDk" 
								target="_blank" 
								rel="noopener noreferrer" 
								className={styles.NYSE}
							>NYSE:NOTE
							</a>
						), the global leader in AI-driven policy intelligence, delivers its deep expertise in legislative tracking, 
						regulatory analysis, and stakeholder engagement through PolicyNote, its flagship platform. Built to ensure 
						the most complete, real-time view of the policy landscape, PolicyNote delivers synthesized, expert-driven 
						analysis integrated with AI-powered monitoring, fueled by the trusted analysis and reporting of CQ and 
						Roll Call, and the grassroots mobilization power of VoterVoice. From the Committee Room to the Board Room, 
						FiscalNote's PolicyNote Suite ensures every user has the unmatched clarity and speed needed to understand 
						and impact policy.
					</p>
				</div>	
				<div className="d-flex justify-content-center"> 
					<Link to='/terms' className={styles.LegalLink}>
						Terms of Use
					</Link>
					<a href='https://fiscalnote.com/privacy' target="_blank" className={styles.LegalLink}>
						Privacy Policy
					</a>	
				</div>
			</div>
		</section>
	)

}

export default Footer;